import React from "react";
import { UserDetailIcon } from "../../components";

const UserUserColumns = ({ item }) => {
  const user = item?.user;

  return (
    <UserDetailIcon
      size={16}
      user={{
        name: user?.name,
        email: user?.email,
        hueShift: user?.id,
      }}
      includeEmail={false}
      variant="rounded"
    />
  );
};

export default UserUserColumns;
